<div class="update-card">
    <div class="update-half">
        <img [src]="update().imgLink" alt="Update 1">
    </div>
    <div>
        <div class="update-half">
            <div class="update-text-container">
                <h3 class="update-text-subtitle">{{update().subtitle}}</h3>
                <h4 class="update-text-title">{{update().title}}</h4>
                <p class="update-text-content">{{update().text}}</p>
                <a class="update-text-link" [style]="{ visibility: update().link ? 'visible': 'hidden'}" [href]="update().link">Más información <fa-icon icon="chevron-right"></fa-icon> </a>
            </div>
        </div>
    </div>
    
</div>